import { useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Box,
    Flex,
    IconSupportAgent,
} from '@myphx-engineering/phx-design-system';
import { openTalkativeUI } from '@phx/talkative';

export const ErrorWidget = () => {
    const { t } = useTranslation();
    return (
        <Flex gap="xxs">
            <IconSupportAgent color="secondary" />
            <Box>
                <Body1 inline>{t('error.persistText')}</Body1>
                <Anchor onClick={openTalkativeUI}>
                    {t('error.contactUs')}
                </Anchor>
                .
            </Box>
        </Flex>
    );
};
